export default [
  {
    id: '591c31ef56514300640002da',
    label: 'Binus University',
  },
  {
    id: '5e4a5fef33d90a2633021dfd',
    label: 'GS FAME Institute of Business',
  },
  {
    id: '5bacc0b1a748dd0531000002',
    label: 'IPMI Business School',
  },
  {
    id: '5a5455858020396fb0000113',
    label: 'PPM School of Management',
  },
  {
    id: '5aba2b748940b70029000005',
    label: 'SAE Indonesia',
  },
  {
    id: '5a5456638020396fb0000341',
    label: 'Trisakti School of Multimedia (STMIK Trisakti)',
  },
  {
    id: '591c31f256514300640003f0',
    label: 'Universitas Paramadina',
  },
  {
    id: '5e5c9bea168d0c2703bc8569',
    label: 'Universitas Bunda Mulia (UBM)',
  },
  {
    id: '5a5456018020396fb0000238',
    label: 'London School of Public Relations (LSPR)',
  },
  {
    id: '5a5457728020396fb00005a8',
    label: 'Institut Teknologi PLN',
  },
]
